module.exports = __webpack_public_path__ + "static/img/quality1.2bfc96f.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/quality1.png
// module id = f/4I
// module chunks = 0